module.exports = __webpack_public_path__ + "img/people-frame-mb.75720a76.webp";